module.exports = __webpack_public_path__ + "static/City Council Portal-e682848bed2d78b48ae20f53dd4d3f8b.svg";